/**
 * `+3` — what a mission is worth, as a chip that rides ON the header band.
 *
 * It is not a Badge, and the difference is where it sits rather than what it says. Every Badge
 * variant is drawn against a CARD; this one is drawn against the band, which is red in Bouquet and
 * midnight in Tuxedo, so it takes its own three tokens rather than inheriting a card-side one that
 * would be invisible on both. Bouquet cuts it as a cream chip with red-panel-deep type — the
 * booth's own points mark — and Tuxedo as a gold-outlined numeral that reads as light on the
 * jacket. Neither changes between modes: the band does not, so this does not either.
 *
 * The sign is part of the value: `+3` is a reward and `3` is a quantity, and the boards write the
 * plus every time.
 *
 * A design-system component: catalogued as `Points` (invented) in `LaunchPad/ideas/_design.md`,
 * so the spec there and the drawing here have to agree.
 */
import { Text } from '@/components/ui/text';
import { cn } from '@/lib/utils';
import { View } from 'react-native';

export function Points({ value, to, className }: { value: number; to?: number; className?: string }) {
  return (
    <View className={cn('bg-points-bg border-points-line shrink-0 self-start rounded-sm border px-2 py-0.5', className)}>
      <Text variant="caption" className="text-points-ink">
        {/* THE DOUBLING IS SHOWN BEFORE THE TAP, NOT AFTER IT.
            The catch-up rule pays double while you are behind, and the chip used to say "+3" on a
            card whose stamp then said "+6" — a reward that only exists in hindsight cannot be the
            reason anybody pressed anything, which is the whole point of a catch-up rule. Both
            numbers, with the arrow, so the offer and the base are legible at once. */}
        +{value}
        {to === undefined ? null : ` → +${to}`}
      </Text>
    </View>
  );
}
